import React from 'react';
import '../../styles/Loader.css'

const Loader = () => {
    return (
        <div className='d-flex align-items-center justify-content-center z-10 text-center' style={{ height: "100%", width: "100%", position: "fixed" }}>
            <span class="loader"></span>
        </div>
    );
};
export default Loader;
